"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var react_router_1 = require("react-router");
var navigationStyles_1 = require("./navigationStyles");
var Routes_1 = require("../../../enum/Routes");
var useAppContext_1 = require("../../../react/useAppContext");
var Translation_1 = require("../Translation/Translation");
var ArrowBackIos_1 = require("@material-ui/icons/ArrowBackIos");
var clsx_1 = require("clsx");
var Navigation = function (_a) {
    var _b = _a.withIcon, withIcon = _b === void 0 ? true : _b, _c = _a.backTextClassName, backTextClassName = _c === void 0 ? '' : _c, _d = _a.backTextVariant, backTextVariant = _d === void 0 ? 'body1' : _d;
    var style = navigationStyles_1.default();
    var history = react_router_1.useHistory();
    var deal = useAppContext_1.default().deal;
    var navigateBack = react_1.useCallback(function () {
        var _a, _b;
        var pathName = window.location.pathname.split('/');
        switch (pathName[pathName.length - 1]) {
            case Routes_1.Routes.PAYMENT.substr(1):
                return history.replace(Routes_1.Routes.RESERVE_ONLINE);
            case Routes_1.Routes.RESERVE_ONLINE.substr(1):
                return (window.location.href = (_b = (_a = deal) === null || _a === void 0 ? void 0 : _a.fullProductConfiguration) === null || _b === void 0 ? void 0 : _b.configurationSourceUrl);
            default:
                return history.goBack();
        }
    }, [history]);
    return (<core_1.Grid className={style.innerBackButtonContainer} item>
      {!!withIcon && <ArrowBackIos_1.default className={style.icon}/>}
      <core_1.Typography onClick={navigateBack} component="span" variant={backTextVariant} data-test="text:navigation:backButton" className={clsx_1.default([style.label, backTextClassName])}>
        <Translation_1.default id="label.back"/>
      </core_1.Typography>
    </core_1.Grid>);
};
exports.default = Navigation;
